import { useState } from "react";

import { Typography } from "@mui/material";
import classNames from "classnames";

import { TPaymentRequest } from "../../../../../@types";
import { usePaymentRequest } from "../../../../../hooks/usePaymentRequest";
import { PaymentRequestItem } from "./PaymentRequestItem";

enum ETab {
	PAID = "paid",
	UNPAID = "unpaid",
	CANCELLED = "cancelled",
}

export function PaymentRequests() {
	const [selectedTab, setSelectedTab] = useState<ETab>(ETab.UNPAID);
	const { paymentRequests } = usePaymentRequest();

	const unpaidPaymentRequests = paymentRequests.filter(
		(paymentRequest) => paymentRequest.status === "Issued",
	);
	const paidPaymentRequests = paymentRequests.filter(
		(paymentRequest) => paymentRequest.status === "Paid",
	);
	const cancelledPaymentRequests = paymentRequests.filter(
		(paymentRequest) => paymentRequest.status === "Cancelled",
	);

	let data: TPaymentRequest[] = [];
	if (selectedTab === ETab.UNPAID) {
		data = unpaidPaymentRequests;
	} else if (selectedTab === ETab.PAID) {
		data = paidPaymentRequests;
	} else if (selectedTab === ETab.CANCELLED) {
		data = cancelledPaymentRequests;
	}

	return (
		<>
			<Typography className="small-title-text bold">
				Payment Requests
			</Typography>
			{paymentRequests.length === 0 && (
				<Typography
					className="normal-text item-separator-tiny"
					textAlign="center">
					You have no payment requests
				</Typography>
			)}
			{paymentRequests.length > 0 && (
				<div className="payment-requests-tab-container item-separator-tiny">
					<div className="first-layer" />
					<div
						className={classNames("second-layer", { [selectedTab]: true })}
					/>
					<div className="third-layer">
						<div
							className="tab-item"
							onClick={() => {
								setSelectedTab(ETab.UNPAID);
							}}>
							<Typography
								className={classNames("normal-text", {
									"bold white-text": selectedTab === ETab.UNPAID,
								})}>
								{`Unpaid (${unpaidPaymentRequests.length})`}
							</Typography>
						</div>
						<div
							className="tab-item"
							onClick={() => {
								setSelectedTab(ETab.PAID);
							}}>
							<Typography
								className={classNames("normal-text", {
									"bold white-text": selectedTab === ETab.PAID,
								})}>
								{`Paid (${paidPaymentRequests.length})`}
							</Typography>
						</div>
						<div
							className="tab-item"
							onClick={() => {
								setSelectedTab(ETab.CANCELLED);
							}}>
							<Typography
								className={classNames("normal-text", {
									"bold white-text": selectedTab === ETab.CANCELLED,
								})}>
								{`Cancelled (${cancelledPaymentRequests.length})`}
							</Typography>
						</div>
					</div>
				</div>
			)}
			{data.length > 0 && (
				<div className="payment-requests-container item-separator-big">
					{data.map((item) => (
						<PaymentRequestItem paymentRequest={item} key={item.id} />
					))}
				</div>
			)}
		</>
	);
}
